import { Injectable } from '@angular/core';
import { CurrentSnapshotService, SnapshotService } from '@vendasta/snapshot';
import { DomainInterface, DomainService } from '@vendasta/domain';
import { Observable, of as observableOf } from 'rxjs';
import { SnapshotSummary, CurrentSnapshot } from './scorecard';
import { catchError, map, publishReplay, refCount, shareReplay } from 'rxjs/operators';

const CACHE_SIZE = 1;

@Injectable()
export class ScorecardService {
  private domainCache$: Map<string, Observable<string>> = new Map<string, Observable<string>>();

  constructor(
    private currentSnapshotService: CurrentSnapshotService,
    private snapshotService: SnapshotService,
    private domainService: DomainService,
  ) {}

  getCurrentSnapshot(businessId: string): Observable<CurrentSnapshot> {
    return this.currentSnapshotService.get(businessId).pipe(
      map((current) => {
        return new CurrentSnapshot(current.snapshot);
      }),
      catchError(() => {
        return observableOf(new CurrentSnapshot({}));
      }),
      publishReplay(1),
      refCount(),
    );
  }

  getSummary(snapshotId: string): Observable<SnapshotSummary> {
    if (snapshotId.startsWith('SNAPSHOT-')) {
      return observableOf(<SnapshotSummary>{ snapshotId: snapshotId, result: 'not-supported' });
    }
    return this.snapshotService.getSummary(snapshotId).pipe(
      map((summary) => {
        return new SnapshotSummary(summary, 'valid');
      }),
      catchError(() => {
        return observableOf(<SnapshotSummary>{ result: 'not-ready' });
      }),
      publishReplay(1),
      refCount(),
    );
  }

  getDomain(partnerId: string): Observable<DomainInterface> {
    if (!this.domainCache$[partnerId]) {
      this.domainCache$[partnerId] = this.domainService
        .getDomainByIdentifier(`/application/ST/partner/${partnerId}`)
        .pipe(
          map((domainResp) => domainResp.primary),
          shareReplay(CACHE_SIZE),
        );
    }

    return this.domainCache$[partnerId];
  }
}
